import { getRemoteConfig, fetchAndActivate, getValue } from "firebase/remote-config";
import { app } from "../firebase";

// ⚠️ FIX: Rimosso trackEvent - l'evento viene già inviato in firebase.js
// Questo previene il TRIPLO invio dell'evento

// Cache per evitare fetch multipli
let cachedValue = null;
let lastFetchTime = 0;
const CACHE_DURATION = 3600000; // 1 ora

// Funzione per ottenere il valore dalla configurazione remota senza hook React
export const getRemoteConfigValue = async (configKey = "UploadDoc_with_preview") => {
  try {
    // ✅ FIX: Usa cache per evitare fetch ripetuti
    const now = Date.now();
    if (cachedValue && (now - lastFetchTime) < CACHE_DURATION) {
      console.log(`Remote Config value (cached) for ${configKey}:`, cachedValue);
      return cachedValue;
    }

    const remoteConfig = getRemoteConfig(app);
    remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

    await fetchAndActivate(remoteConfig);
    
    const value = getValue(remoteConfig, configKey);
    console.log(`Remote Config value for ${configKey}:`, value.asString());
    
    // ✅ FIX: Salva in cache
    cachedValue = value.asString();
    lastFetchTime = now;
    
    // ⚠️ RIMOSSO: trackEvent già inviato in firebase.js
    // Non serve inviarlo anche qui
    
    return value.asString();
  } catch (error) {
    console.error('Error fetching Remote Config:', error);
    return null;
  }
}; 